import { defineMessages } from "react-intl";

import { AvgLevel } from "../../enums/AvgLevel";

export const messages = defineMessages({
  [AvgLevel.ORG]: {
    id: "reports.overview.grossMetric.orgAverage",
    defaultMessage: "Org Average: {average}",
    description: "Metric card org average label on Overview Screen.",
  },
  [AvgLevel.TEAM]: {
    id: "reports.overview.grossMetric.teamAverage",
    defaultMessage: "Team Average: {average}",
    description: "Metric card team average label on Overview Screen.",
  },
});
